import { ISheetField} from "Components/SheetCalculatur/Models";



export interface ISheetProvider{
    getFields() : Map<string,ISheetField>;
    setValue(key: string, value: Number): void;
    getValue(address: string): Function;

}


export abstract class SheetProvider implements ISheetProvider {

    protected fields: any;

    constructor() {


    }
    
    abstract getFields(): Map<string, ISheetField>;


    public setValue(key: string, value: Number): void {
        var input: ISheetField = this.fields[key];
        if (input == null)
            return;

        input.value = () => { return value };
    }

    public getValue(address: string) {
        var input: ISheetField = this.fields[address];
        if (input == null)
            return NaN;

        return input.value();
    }

    protected addField(key: string, UXIndex: string, value: Function) {
        this.fields[key] = <ISheetField>{
            key: key,
            UIIndex: UXIndex,
            value: value,
        };
    }

}

